import { createReducer } from 'redux-act';
import { TLegacyErrors } from '@alycecom/services';

import { MessageType } from '../../../../store/types/Message.types';

import { applyMessageHeader, dataLoadFail, dataLoadRequest, dataLoadSuccess, setShouldResetFlow } from './data.actions';
import { IGiftData } from './data.types';

export interface IDataState {
  isLoading: boolean;
  isLoaded: boolean;
  shouldResetFlow: boolean;
  gift: IGiftData;
  errors: TLegacyErrors;
}

export const initialState: IDataState = {
  isLoading: false,
  isLoaded: false,
  shouldResetFlow: true,
  errors: {},
  gift: {
    hashId: '',
    giftLanguage: '',
    type: '',
    countryId: null,
    isClaimed: false,
    reverseReason: '',
    actions: {
      exchange: false,
      accept: false,
      donate: false,
    },
    message: {
      type: MessageType.text,
      content: '',
      header: '',
    },
    product: {
      id: 0,
      image: '',
      name: '',
      provider: '',
      options: '',
      hasOptions: false,
      isAddressRequired: false,
      isDonation: false,
      isTangoCard: false,
      typeId: 0,
      countryId: 0,
      denomination_currency_id: 0,
      brand: { name: '' },
      hasExternalFulfillment: false,
      oneTimeCodeVerification: false,
      hasRangeDenomination: false,
    },
    customizations: {
      redirectUrl: null,
      redirectHeader: null,
      redirectButton: null,
      redirectConfirm: false,
      redirectMessage: null,
      hidePrefilledReasons: false,
      hideHeaders: false,
      messageImageUrl: null,
      mobileMessageImageUrl: null,
    },
    calendarProvider: null,
  },
};

const reducer = createReducer<IDataState>({}, initialState);

reducer
  .on(dataLoadRequest, state => ({
    ...state,
    isLoading: true,
  }))
  .on(dataLoadSuccess, (state, payload) => ({
    ...state,
    isLoaded: true,
    isLoading: false,
    gift: payload,
  }))
  .on(dataLoadFail, (state, payload) => ({
    ...state,
    isLoading: false,
    errors: payload,
  }));

reducer.on(setShouldResetFlow, (state, payload) => ({
  ...state,
  shouldResetFlow: payload,
}));

reducer.on(applyMessageHeader, (state, payload) => ({
  ...state,
  gift: {
    ...state.gift,
    message: {
      ...state.gift.message,
      header: payload,
    },
  },
}));

export default reducer;
